import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/pass/rule/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/pass/rule/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/pass/rule/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/pass/rule/save', params, options);

export const update = (params, options) =>
  request.post('/api/park/pass/rule/update', params, options);

export const getPassRuleSelection = (params, options) =>
  request.post('/api/park/pass/rule/selections1', qs.stringify(params), options);
